export default {
    API_URL: process.env.REACT_APP_API_ENDPOINT,
    SOCKET_ENDPOINT: process.env.REACT_APP_SOCKET_ENDPOINT,
    MESSAGE_API_URL: process.env.REACT_APP_WBPM_MESSAGE_ENDPOINT,
    SPERANT_API_URL: process.env.REACT_APP_WBPM_SPERANT_ENDPOINT,
    CAMPAIGNS_API_URL: process.env.REACT_APP_CAMPAIGNS_API_URL,
    AI_ANALYSIS_API_URL: process.env.REACT_APP_AI_ANALYSIS_URL,
    AUTH_BACKEND: 'Dummy'
}